// @ts-nocheck

import React from 'react';



import {
  contractVehiclePlanVehicleApi,
  contractVehicleApi } from
'./../../../../../../../lib/api';
import { convertContractVehicleToString } from './../../../../../../../lib/helpers';

import AutocompleteSelect from './../../../../../../../components/selects/AutocompleteSelect';

export default (
selectProps) =>
{
  const fetchContractVehicles = async (params) => {
    const contractVehiclePlanVehicles = await contractVehiclePlanVehicleApi.fetch(
      {
        ...params,
        contractVehiclePlanId: selectProps.contractVehiclePlanId,
        pageSize: undefined
      }
    );
    return {
      ...contractVehiclePlanVehicles,
      data: contractVehiclePlanVehicles.data.map(
        (contractVehiclePlanVehicle) => contractVehiclePlanVehicle.contractVehicle
      )
    };
  };
  const fetchContractVehicle = async (id) => {
    return await contractVehicleApi.fetchContractVehicle(id);
  };
  return (
    <AutocompleteSelect
      fetch={fetchContractVehicles}
      fetchSingle={fetchContractVehicle}
      notFoundText="ТС не найдены"
      placeholder="Выберите ТС"
      renderOption={(contractVehicle, Option) =>
      <Option
        key={contractVehicle.id}
        value={contractVehicle.id}
        contractVehicle={contractVehicle}>

          {convertContractVehicleToString(contractVehicle)}
        </Option>
      }
      {...selectProps} />);


};
